"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Route = exports.useRouteContext = exports.RouteContextConsumer = exports.RouteContextProvider = exports.RouteContext = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const Routing_1 = require("../../common/Routing");
(function (history) {
    const pushState = history.pushState;
    history.pushState = function (state, title, url) {
        // @ts-ignore
        if (typeof history.onpushstate == "function") {
            // @ts-ignore
            history.onpushstate({ state: state });
        }
        // @ts-ignore
        const result = pushState.apply(history, arguments);
        // Dispatch a custom event 'statechanged'
        window.dispatchEvent(new CustomEvent("statechanged", { detail: state }));
        return result;
    };
})(window.history);
const CURRENT_PATH = window.location.pathname;
exports.RouteContext = (0, react_1.createContext)({
    currentWindowPath: CURRENT_PATH,
    parentPath: "",
    params: {},
    isTopLevel: true,
});
exports.RouteContextProvider = exports.RouteContext.Provider, exports.RouteContextConsumer = exports.RouteContext.Consumer;
/**
 * Access Route path and parameter information.
 * */
const useRouteContext = () => (0, react_1.useContext)(exports.RouteContext);
exports.useRouteContext = useRouteContext;
/**
 * Organize nested routes with parameters and integrate with the browser history.
 * */
const Route = ({ 
/**
 * Use `:` as the first character to denote a parameter in the path.
 * */
path = "", onParamsChange, exact = false, children, }) => {
    const [currentPath = "", setCurrentPath] = (0, react_1.useState)(CURRENT_PATH);
    const { currentWindowPath = "", parentPath = "", params: parentParams = {}, isTopLevel, } = (0, exports.useRouteContext)();
    const targetCurrentPath = (0, react_1.useMemo)(() => (isTopLevel ? currentPath : currentWindowPath), [isTopLevel, currentPath, currentWindowPath]);
    const fullPath = (0, react_1.useMemo)(() => (0, Routing_1.mergeStringPaths)(parentPath, path), [parentPath, path]);
    const newParams = (0, react_1.useMemo)(() => (0, Routing_1.getParamsAndTestPath)(targetCurrentPath, fullPath, exact), [targetCurrentPath, fullPath, exact]);
    const params = (0, react_1.useMemo)(() => (Object.assign(Object.assign({}, parentParams), (newParams ? newParams : {}))), [parentParams, newParams]);
    const newRouteContext = (0, react_1.useMemo)(() => ({
        currentWindowPath: targetCurrentPath,
        parentPath: fullPath,
        params,
        isTopLevel: false,
    }), [targetCurrentPath, fullPath, params]);
    (0, react_1.useEffect)(() => {
        if (onParamsChange) {
            onParamsChange(params);
        }
    }, [params, onParamsChange]);
    (0, react_1.useEffect)(() => {
        if (isTopLevel) {
            const handleAnchorClick = (event) => {
                let target = event.target;
                while (target && target.nodeName !== "A") {
                    target = target.parentNode;
                }
                if (target && target.nodeName === "A") {
                    const aTarget = target;
                    const href = aTarget.getAttribute("href");
                    try {
                        new URL(href ? href : "");
                        // Full URL
                    }
                    catch (error) {
                        // Partial URL
                        const newPath = (0, Routing_1.resolvePath)(window.location.pathname, href ? href : "");
                        event.preventDefault();
                        history.pushState({}, "", newPath);
                        setCurrentPath(newPath);
                    }
                }
            };
            const handlePopOrReplaceState = () => {
                setCurrentPath(window.location.pathname);
            };
            window.document.addEventListener("click", handleAnchorClick);
            window.addEventListener("popstate", handlePopOrReplaceState);
            window.addEventListener("statechanged", handlePopOrReplaceState);
            return () => {
                window.document.removeEventListener("click", handleAnchorClick);
                window.removeEventListener("popstate", handlePopOrReplaceState);
                window.removeEventListener("statechanged", handlePopOrReplaceState);
            };
        }
    }, [isTopLevel]);
    return newParams ? ((0, jsx_runtime_1.jsx)(exports.RouteContextProvider, { value: newRouteContext, children: children })) : null;
};
exports.Route = Route;
